import { z } from "zod";
import { nameSchema } from "./common.js";
/**
 * A product an organization prints reward codes for. Choosing one when issuing
 * a batch fills in the batch's name and points, and stamps the product on the
 * sticker sheets and in the karigar's history.
 */
const skuSchema = z
    .string()
    .trim()
    .toUpperCase()
    .min(1, "Enter a SKU")
    .max(50)
    .regex(/^[A-Z0-9][A-Z0-9._\-/]*$/, "Use letters, numbers, - . _ or /");
const pointsSchema = z.number().int().min(1).max(100_000);
export const createProductSchema = z.object({
    name: nameSchema,
    sku: skuSchema,
    pointsPerCode: pointsSchema,
});
export const updateProductSchema = z.object({
    name: nameSchema.optional(),
    sku: skuSchema.optional(),
    pointsPerCode: pointsSchema.optional(),
    status: z.enum(["active", "inactive"]).optional(),
});
//# sourceMappingURL=product.js.map